var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 11.0938H18.75V9.21875C18.75 8.96094 18.5475 8.75 18.3 8.75H17.4C17.1525 8.75 16.95 8.96094 16.95 9.21875V11.0938H15.15C14.9025 11.0938 14.7 11.3047 14.7 11.5625V12.5C14.7 12.7578 14.9025 12.9688 15.15 12.9688H16.95V14.8438C16.95 15.1016 17.1525 15.3125 17.4 15.3125H18.3C18.5475 15.3125 18.75 15.1016 18.75 14.8438V12.9688H20.55C20.7975 12.9688 21 12.7578 21 12.5V11.5625C21 11.3047 20.7975 11.0938 20.55 11.0938ZM9.3 12.5C11.2884 12.5 12.9 10.8213 12.9 8.75C12.9 6.67871 11.2884 5 9.3 5C7.31156 5 5.7 6.67871 5.7 8.75C5.7 10.8213 7.31156 12.5 9.3 12.5ZM11.82 13.4375H11.3503C10.7259 13.7363 10.0312 13.9062 9.3 13.9062C8.56875 13.9062 7.87687 13.7363 7.24969 13.4375H6.78C4.69312 13.4375 3 15.2012 3 17.375V18.5938C3 19.3701 3.60469 20 4.35 20H14.25C14.9953 20 15.6 19.3701 15.6 18.5938V17.375C15.6 15.2012 13.9069 13.4375 11.82 13.4375Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAdd);
export default __webpack_public_path__ + "static/media/personAdd.41aa79b5.svg";
export { ForwardRef as ReactComponent };